import * as React from "react";
import DataBaseComponent, {DataBaseComponentState} from "components/DataBaseComponent";
import PaperLayout from "components/PaperLayout";
import repository from "client/repository";
import { FileResource } from "~/client/resources/fileResource";
import DiagnosticFilesTable from "./DiagnosticFilesTable";

interface Props {
    instanceId: string;
    breadcrumbTitle: string;
    breadcrumbChip: JSX.Element;
}

interface State extends DataBaseComponentState {
    files?: FileResource[];
}

class InstanceDiagnosticFiles extends DataBaseComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
        };
    }

    async componentDidMount() {
        await this.loadData();
    }

    render() {
        const files = this.state.files;
        return (
            <PaperLayout busy={this.state.busy} errors={this.state.errors} title={files && "Diagnostic Files"} breadcrumbTitle={this.props.breadcrumbTitle} breadcrumbChip={this.props.breadcrumbChip}>
                <DiagnosticFilesTable
                    instanceId={this.props.instanceId}
                    files={files}
                    doBusyTask={this.doBusyTask}
                    onFilesChanged={this.loadData}
                />
            </PaperLayout>
        );
    }

    loadData = async () => {
        await this.doBusyTask(async () => {
            this.setState({ files: await repository.HostedInstances.getDiagnosticFiles(this.props.instanceId) });
        });
    }
}

export default InstanceDiagnosticFiles;
